import React from 'react';
import type { RaceEvent } from '../types';

interface EventDropdownProps {
  events: RaceEvent[];
  selectedEventId: string | null;
  onSelectEvent: (eventId: string) => void;
  loading: boolean;
}

/** Format date for display in dropdown. */
function formatDate(dateStr?: string): string {
  if (!dateStr) return 'TBD';
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return dateStr;
  }
}

/**
 * Dropdown selector for upcoming race events.
 * Requirements: 1.1, 1.2, 1.3
 */
const EventDropdown: React.FC<EventDropdownProps> = ({
  events,
  selectedEventId,
  onSelectEvent,
  loading,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (value) {
      onSelectEvent(value);
    }
  };

  if (loading) {
    return (
      <div className="event-dropdown">
        <label htmlFor="event-select">Select Event</label>
        <select id="event-select" disabled>
          <option>Loading events...</option>
        </select>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="event-dropdown">
        <label htmlFor="event-select">Select Event</label>
        <select id="event-select" disabled>
          <option>No events available</option>
        </select>
      </div>
    );
  }

  return (
    <div className="event-dropdown">
      <label htmlFor="event-select">Select Event</label>
      <select
        id="event-select"
        value={selectedEventId || ''}
        onChange={handleChange}
      >
        <option value="">-- Select an event --</option>
        {events.map((event) => (
          <option key={event.raceId} value={event.raceId}>
            {event.name} - {formatDate(event.date)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default EventDropdown;
